import {MatchmakingCancelReason} from '../../../../../../../../shared/matchmaking/MatchmakingEnums'
import {SocketMatchmakingSend} from '../../../../../../../shared/scripts/socket/SocketMatchmakingSend'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'
import {UIMMatchmakingSearching1v1View} from './UIMMatchmakingSearching1v1View'
import {UIMMatchmakingSearchingClassic4PView} from './UIMMatchmakingSearchingClassic4PView'
import {UIMMatchmakingSearchingCnKView} from './UIMMatchmakingSearchingCnKView'
import {MatchmakingStatusUpdate} from '../../../../../../../../shared/matchmaking/MatchmakingInterfaces'
import {UIMMatchmakingActionsController} from '../UIMMatchmakingActionsController'
import {BotsMatchType, MatchmakingMatchTypes, MatchType} from '@colonist/game-base-types'
import {getMatchTypeEligibilityAndCreatePopup, isBotMatchSelected, startBotGame} from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient'
import {ClientUserState} from '../../../../../../../shared/scripts/ClientUserState'
import {UIMMatchmakingSearchingShuffleView} from './UIMMatchmakingSearchingShuffleView'

export class UIMMatchmakingController {
    private matchmakingSearchingView?: UIMMatchmakingSearchingView
    readonly matchmakingActionsController: UIMMatchmakingActionsController

    constructor() {
        this.matchmakingActionsController = new UIMMatchmakingActionsController()
    }

    async startGame(matchType: MatchType) {
        if(isBotMatchSelected(matchType)) {
            startBotGame(matchType as BotsMatchType)
            return
        }

        const matchmakingType = matchType as MatchmakingMatchTypes

        const {isEligible, createPopup} = getMatchTypeEligibilityAndCreatePopup(matchmakingType)
        createPopup?.()
        if(!isEligible) return

        await ClientUserState.requireUser()

        switch(matchmakingType) {
            case MatchmakingMatchTypes.UnrankedClassic1v1:
            case MatchmakingMatchTypes.RankedClassic1v1:
                this.matchmakingSearchingView = new UIMMatchmakingSearching1v1View(this, matchmakingType)
                break
            case MatchmakingMatchTypes.UnrankedClassic4P:
            case MatchmakingMatchTypes.RankedClassic4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingClassic4PView(this, matchmakingType)
                break
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingCnKView(this)
                break
            case MatchmakingMatchTypes.UnrankedShuffle:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingShuffleView(this)
                break
            default:
                return
        }

        this.matchmakingActionsController.sendFindGameMessageToServer(matchmakingType)
    }

    stopSearching() {
        this.matchmakingSearchingView?.removeFromDOM()
        SocketMatchmakingSend.sendCancelFindGame(MatchmakingCancelReason.ClickedCancel)
    }

    removeSearchingScreen() {
        this.matchmakingSearchingView?.removeFromDOM()
    }

    updateMatchmakingStatus(matchmakingStatusUpdate: MatchmakingStatusUpdate) {
        this.matchmakingSearchingView?.updateStatus(matchmakingStatusUpdate)
    }
}
